import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useCallback } from 'react';
import Joyride, { ACTIONS, EVENTS, LIFECYCLE, STATUS, } from 'react-joyride';
import { useAction, useAppSelector } from 'shared/hooks/redux/hooks';
import { initialStoreHelper, passUiLearning, setTipIndex, skipUiLearning, stop_learning, } from 'console/ui-guide/redux/actions';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router';
import { useNavigateAccountDialog } from 'shared/hooks/router';
const local = {
    back: 'Назад',
    close: 'Выход',
    last: 'Конец',
    next: 'Далее',
    open: 'Открыть диалог',
    skip: 'Завершить',
};
const style = {
    buttonClose: {
        display: 'none',
    },
};
function UiGuideViewerImpl(props) {
    const { steps, running_key } = props;
    const steps_index = useAppSelector((state) => state.ui_guide_state.learning.current_step_index);
    const _setTipIndex = useAction(setTipIndex);
    const _stop_learning = useAction(stop_learning);
    const set_learning_skip = useAction(skipUiLearning);
    const set_learning_finish = useAction(passUiLearning);
    const initiateStoreHelpers = useAction(initialStoreHelper);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const navigateAccountDialog = useNavigateAccountDialog();
    const doStep = useCallback(async (timeout, callbacks) => {
        for (const action of callbacks) {
            dispatch(action());
        }
        if (timeout) {
            await new Promise((resolve) => setTimeout(resolve, timeout));
        }
    }, [dispatch]);
    const forwardStep = useCallback(async (new_index) => {
        const step = steps[new_index];
        if (step) {
            await doStep(step.timeout, step.forward_callbacks);
        }
        _setTipIndex(new_index, step?.id ?? null);
    }, [doStep, steps, _setTipIndex]);
    const backwardStep = useCallback(async (new_index) => {
        const step = steps[new_index];
        if (step) {
            await doStep(step.timeout, step.back_callbacks);
            _setTipIndex(new_index, step.id);
        }
    }, [doStep, _setTipIndex, steps]);
    const handleTipsCallback = useCallback(async (data) => {
        const { action, index, status, type } = data;
        if (
        //@ts-ignore
        data.step?.id == 'open_left_menu' &&
            action == ACTIONS.NEXT &&
            data.lifecycle == LIFECYCLE.COMPLETE) {
            navigateAccountDialog();
        }
        if ([EVENTS.STEP_AFTER, EVENTS.TARGET_NOT_FOUND].includes(type)) {
            if (action == ACTIONS.PREV) {
                await backwardStep(index - 1);
                return;
            }
            await forwardStep(index + 1);
        }
        else if (STATUS.SKIPPED === status) {
            _stop_learning();
            set_learning_skip(running_key);
        }
        else if (STATUS.FINISHED == status) {
            _stop_learning();
            set_learning_finish(running_key);
        }
        if (
        //@ts-ignore
        data.step?.id == 'design_package' &&
            action == ACTIONS.NEXT &&
            data.lifecycle == LIFECYCLE.COMPLETE) {
            navigate('/billing/more-icons');
        }
    }, [
        _stop_learning,
        forwardStep,
        backwardStep,
        set_learning_finish,
        set_learning_skip,
        running_key,
    ]);
    return (_jsx(Joyride, { run: true, steps: steps, stepIndex: steps_index, callback: handleTipsCallback, continuous: true, scrollToFirstStep: true, showSkipButton: true, disableScrollParentFix: true, disableScrolling: true, disableOverlayClose: true, 
        // hideBackButton
        locale: local, styles: style, getHelpers: initiateStoreHelpers }));
}
export const UiGuideViewer = memo(function UiGuideViewer() {
    const running_key = useAppSelector((state) => state.ui_guide_state.learning.running_key);
    const ui_guide_groups = useAppSelector((state) => state.ui_guide_state.ui_guide_groups.data);
    const loaded_ui_guide = useAppSelector((state) => state.ui_guide_state.ui_guide_groups.loaded);
    if (running_key == null || ui_guide_groups == null || !loaded_ui_guide) {
        return null;
    }
    const steps = ui_guide_groups.find(({ id }) => running_key === id)?.steps;
    if (!steps) {
        return null;
    }
    return _jsx(UiGuideViewerImpl, { running_key: running_key, steps: steps });
});
